import { Col, Row, Segmented, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useGetSupportedPhoneBrands,
  useGetSupportedPhoneModelList,
} from "../../../../hooks/SupportedDevice/supporteddevice.hooks";
import mobile from "../../images/mobile.png";
import styles from "./style.module.scss";
import "./style.scss";

const DeviceArea = () => {
  const { t } = useTranslation();
  const [segmentedItems, setSegmentedItems] = useState<string[]>([]);
  const [selectedBrand, setSelectedBrand] = useState<any>("");
  const { data } = useGetSupportedPhoneBrands({});
  const { data: modelList, isPending: isLoadingModelList } =
    useGetSupportedPhoneModelList(
      { brand: selectedBrand },
      { enabled: !!selectedBrand }
    );

  useEffect(() => {
    if (data) {
      const items: string[] = [];
      data?.map((item: { brand: string; id: number }) =>
        items.push(item.brand)
      );
      if (items.length > 0) {
        setSelectedBrand(items[0]);
      } else {
        setSelectedBrand("");
      }
      setSegmentedItems(items);
    }
  }, [data]);
  return (
    <div className={styles.deviceContainer} id="deviceArea">
      <div className={styles.supportedDevice}>
        <div className={styles.description}>
          <div className={styles.title}>{t("normal.esim.support.device")}</div>
          <div className={styles.warning}>
            {t("supportedDevice.modal.warning")}
          </div>
          <ul className={styles.pcHint}>
            {new Array(3).fill(null).map((item, index) => (
              <li
                key={index}
                className={styles.hint}
                dangerouslySetInnerHTML={{
                  __html: t(`supportedDevice.modal.hint${index + 1}`),
                }}
              />
            ))}
          </ul>
        </div>
        <div className={styles.deviceList}>
          <Segmented
            block
            options={segmentedItems}
            value={selectedBrand}
            onChange={(val) => setSelectedBrand(val)}
            className="supported-device-segmented"
          />
          <div className={styles.modelListContainer}>
            <Spin spinning={isLoadingModelList || !modelList}>
              <Row gutter={[8, 8]}>
                {modelList?.map(
                  (item: { id: number; brand: string; model: string }) => (
                    <Col span={8} className="gutter-row" key={item.model}>
                      <div className={styles.modelText}>{item.model}</div>
                    </Col>
                  )
                )}
              </Row>
            </Spin>
            {selectedBrand?.toLowerCase() === "apple" ? (
              <div className={styles.appleHint}>
                {t("supportedDevice.modal.ios.hint")}
                {/* <div>{t("supportedDevice.modal.ios.hint.two")}</div> */}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
        <ul className={styles.mobileHint}>
          {new Array(3).fill(null).map((item, index) => (
            <li
              key={index}
              className={styles.hint}
              dangerouslySetInnerHTML={{
                __html: t(`supportedDevice.modal.hint${index + 1}`),
              }}
            />
          ))}
        </ul>
      </div>
      <img className={styles.mobileImg} src={mobile} alt="device_img" />
    </div>
  );
};

export default DeviceArea;
